module.exports = __webpack_public_path__ + "/login_ui/img/ae-68e814338f80efcb9c9b0a59dbb57ada.svg";